import uuid from 'uuid/v1';
import { assertString } from '@Utils/assert';
import { dialogs as dialogsSelector, dialog as dialogSelector } from './DialogsSelectors';
import { closeDialogType, removeDialogType, updateDialogType } from './DialogsConstants';
import { typeOfStructureDialog } from '../StructureDialog/StructureDialogConstants';

const animationTimeout = 350;

export function dialogAction(actionType, payload) {
  const { id } = payload;
  const resultId = id || uuid();

  return {
    type: actionType,
    payload: {
      backdrop: true,
      closeOnBackdropClick: false,
      ...payload,
      id: resultId,
    },
  };
}

export function updateDialog(payload) {
  return (dispatch) => {
    const { dialogType } = payload;
    assertString(dialogType, 'dialogType');
    if (dialogType !== typeOfStructureDialog) {
      // eslint-disable-next-line no-use-before-define
      dispatch(closeStructureDialog()); // close structure dialog if another opens
    }
    return dispatch(dialogAction(updateDialogType, payload));
  };
}

export function removeDialog(payload) {
  assertString(payload.id, '"closeDialog" action has to have string id');

  return dialogAction(removeDialogType, payload);
}

export function closeDialog(payload) {
  const { id } = payload || {};
  assertString(id, '"closeDialog" action has to have string id');

  return (dispatch, getState) => {
    const dialog = dialogSelector(getState(), { id });
    const { animated } = dialog || {};
    if (animated === false) {
      dispatch(removeDialog(payload));
    } else {
      dispatch(dialogAction(closeDialogType, payload));
      setTimeout(() => {
        dispatch(removeDialog(payload));
      }, animationTimeout);
    }
  };
}

export function closeLastDialogByConditionfactory(getDialogFn) {
  return function closeLastDialogByCondition() {
    return (disaptch, getState) => {
      const state = getState();
      const dialogs = dialogsSelector(state);

      const lastDialogByCondition = getDialogFn(dialogs);

      if (!lastDialogByCondition) {
        return;
      }

      const action = closeDialog({
        id: lastDialogByCondition.id,
      });

      disaptch(action);
    };
  };
}

export const closeLastDialogWithBackdrop = closeLastDialogByConditionfactory((dialogs) => {
  return dialogs.findLast((item) => {
    const { backdrop, closeOnBackdropClick } = item;

    return backdrop && closeOnBackdropClick;
  });
});

export const closeLastDialog = closeLastDialogByConditionfactory((dialogs) => {
  return dialogs.last();
});

export const closeStructureDialog = closeLastDialogByConditionfactory((dialogs) => {
  return dialogs.find((v) => v.dialogType === typeOfStructureDialog);
});
